import "@sphtech/dmg-design-system/dist/theme-peak.css";
import "@sphtech/dmg-design-system/assets/peak/fonts.css";

import Newsticker from "@components/Modules/Newsticker/Newsticker";
import { configSite } from "@pub/config";
import { BaseLayout, CustomClassContext } from "@sphtech/dmg-design-system";
import { useLocation } from "react-router";

import { configHeader, hamburgermenuSvgSource } from "./config/configHeader";
import customStyle from "./custom.module.css";
import logoSvgSource from "./logo.svg?raw";
import { RoutePaths } from "./routePaths";

type PEAKBaseLayoutProps = {
  ArticleTitle?: string;
  children: React.ReactNode;
  ads?: boolean;
  leaderboard?: boolean;
  skipMobileBanner?: boolean;
};

/**
 * Reusable Base layout specific to PEAK.
 */
const PEAKBaseLayout = ({
  ArticleTitle,
  children,
  ads = true,
  leaderboard = true,
  skipMobileBanner,
}: PEAKBaseLayoutProps) => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  const isLeadingLadies = location.pathname === "/leading-ladies";
  const isLatestStories = location.pathname === "/latest-stories";

  return (
    <CustomClassContext.Provider
      value={{
        categoryLayout: {
          ...(isLeadingLadies && {
            sectionContainer:
              customStyle["categorySectionContainerLeadingLadies"],
            infoContainer: customStyle["categoryInfoContainerLeadingLadies"],
          }),
          ...(isLatestStories && {
            categoryHeading: customStyle["categoryHeadingLatestStories"],
          }),
        },
        button: {
          primary: customStyle["peak-button-primary"],
          secondary: customStyle["peak-button-secondary"],
        },
        textLink: customStyle["peak-text-link"],
        anchorBlock: {
          verticalLine: customStyle["peak-anchor-block"],
          summaryItem: customStyle["peak-anchor-block-summary-item"],
        },
        relatedItem: {
          verticalLine: customStyle["verticalLine"],
          firstItem: customStyle["verticalLineFirstItem"],
        },
        videoGallery: {
          verticalLine: customStyle["peak-video-gallery"],
        },
        magazineListing: {
          verticalLine: customStyle["peak-magazine-listing"],
        },
        navLinks: {
          verticalLineHeader: customStyle["peak-nav-links"],
          verticalLineFooter: customStyle["peak-nav-links"],
        },
        callBlock: {
          verticalLine: customStyle["peak-call-block"],
        },
        authorProfile: {
          verticalLine: customStyle["verticalLine"],
        },
      }}
    >
      <BaseLayout
        siteName={configSite.name}
        ArticleTitle={ArticleTitle}
        ads={ads}
        leaderboard={leaderboard}
        NewsTicker={<Newsticker />}
        RoutePaths={RoutePaths}
        svgSource={logoSvgSource}
        svgHamburgerMenu={hamburgermenuSvgSource}
        mciText={
          <span suppressHydrationWarning>
            MDDI (P) 062/10/2024. Published by SPH Media Limited, Co. Regn. No.
            202120748H. Copyright © {currentYear} SPH Media Limited. All rights
            reserved.
          </span>
        }
        socialIconProps={configHeader.socialMedia}
        megaMenuProps={{
          NewsLetterProps: configHeader.megaMenu.newsletter,
          CloseButtonProps: configHeader.megaMenu.closeButton,
          divider: configHeader.megaMenu.divider?.footer,
        }}
        skipMobileBanner={skipMobileBanner}
        currentLocation={location}
      >
        {children}
      </BaseLayout>
    </CustomClassContext.Provider>
  );
};

export default PEAKBaseLayout;
